/* =========================================================
   Maison · Recomendaciones de la ficha de producto
   - <maison-complete-set>   (blocks/maison-complete-set.liquid)    "Completá el set"
   - <maison-recommendations> (sections/maison-recommendations.liquid) "Completá el look" y "También te puede gustar"

   Fuentes (todas renderizadas por Shopify con sections/maison-product-pool.liquid):
   - /recommendations/products?intent=complementary  → piezas elegidas en Search & Discovery
   - /recommendations/products?intent=related        → algoritmo de Shopify
   - /collections/vendors?q=MARCA                    → piezas de la misma marca (máx. 50)
   Reemplaza la descarga del catálogo completo de versiones anteriores.
   ========================================================= */
(function () {
  'use strict';

  if (window.MaisonRecommendations) return;

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('maison-config').textContent) || {}; } catch (e) {}
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var POOL_SECTION = 'maison-product-pool';

  /* ---------- Tipos de prenda ---------- */
  var LOOK = {
    shoes: ['remeras', 'pantalones', 'buzos', 'hats', 'camperas', 'bolsos', 'shorts'],
    tops: ['pantalones', 'shoes', 'shorts', 'hats', 'camperas', 'bolsos'],
    layers: ['pantalones', 'remeras', 'shoes', 'hats', 'bolsos'],
    bottoms: ['remeras', 'buzos', 'shoes', 'camisas', 'hats'],
    access: ['remeras', 'buzos', 'shoes', 'pantalones']
  };
  function cleanType(type) { return (type || '').toLowerCase().replace(/^(men's|mens|men|women's|womens|women)\s*-\s*/, ''); }
  function family(type) {
    var t = cleanType(type);
    if (/sneaker|zapat|slide|shoe|ojota/.test(t)) return 'shoes';
    if (/pantal|short|jean|denim|jogger|trouser|pant/.test(t)) return 'bottoms';
    if (/remera|t-shirt|tee|tank|camisa|polo|shirt/.test(t) && !/sweatshirt/.test(t)) return 'tops';
    if (/buzo|sweater|sweatshirt|knit|cardigan|campera|chaleco|hood|jacket|coat|vest|outerwear/.test(t)) return 'layers';
    return 'access';
  }
  function bucket(type) {
    var t = cleanType(type);
    if (/sneaker|zapat|slide|shoe|ojota/.test(t)) return 'shoes';
    if (/short/.test(t)) return 'shorts';
    if (/pantal|jean|denim|jogger|trouser|pant/.test(t)) return 'pantalones';
    if (/remera|t-shirt|tee|tank|polo/.test(t)) return 'remeras';
    if (/buzo|sweater|sweatshirt|knit|cardigan|hood/.test(t)) return 'buzos';
    if (/camisa|shirt/.test(t)) return 'camisas';
    if (/campera|chaleco|jacket|coat|vest|outerwear/.test(t)) return 'camperas';
    if (/acces/.test(t)) return 'accesorios';
    if (/hat|gorra/.test(t)) return 'hats';
    if (/bolso|bag/.test(t)) return 'bolsos';
    return t;
  }

  /* ---------- Datos ---------- */
  var cache = {};
  function pool(url) {
    if (cache[url]) return cache[url];
    cache[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.map.call(doc.querySelectorAll('template[data-handle]'), function (tpl) {
          var d = tpl.dataset;
          return {
            h: d.handle, t: d.title || '', v: d.vendor || '', y: d.type || '',
            a: d.available === 'true', x: d.intl === 'true', url: d.url,
            img: d.image || '', alt: d.imageAlt || '', price: d.price || '', sizes: d.sizes || '',
            tpl: tpl
          };
        });
      })
      .catch(function () { return []; });
    return cache[url];
  }
  function withSection(url) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + POOL_SECTION; }
  function vendorPool(vendorUrl) { return vendorUrl ? pool(withSection(vendorUrl)) : Promise.resolve([]); }
  function recPool(productId, intent) {
    return pool(withSection(ROOT + 'recommendations/products?product_id=' + productId + '&limit=10&intent=' + intent));
  }

  // Cada mercado recomienda solo su catálogo; en el principal, solo piezas con stock
  function marketOk(p) {
    if (!CFG.catalogTag) return true;
    return CFG.intl ? p.x : !p.x;
  }
  function eligible(p) {
    return marketOk(p) && (CFG.intl || p.a);
  }
  function uniq(list) {
    var seen = {};
    return list.filter(function (p) { if (seen[p.h]) return false; seen[p.h] = true; return true; });
  }
  function idle(fn) {
    (window.requestIdleCallback || function (cb) { return setTimeout(cb, 600); })(fn, { timeout: 2500 });
  }

  // Piezas que ya se muestran en "Completá el set" (para no repetirlas abajo)
  var setTaken = {};
  var resolveSet = null;
  var setDone = new Promise(function (resolve) { resolveSet = resolve; });

  /* ---------- Completá el set ---------- */
  var NOISE = /^(hoodie|hoody|hooded|hood|pullover|sweatshirt|sweater|crewneck|crew|neck|zip|zipped|up|jacket|pants|pant|sweatpants|sweatpant|trousers|trouser|jeans|jean|denim|shorts|short|tshirt|shirt|tee|polo|hat|cap|set|jogger|joggers|track|trackpants|trackpant|trucker|beanie|bag|the|and|with|for|of|men|mens|women|womens|large|fit|oversized|regular|logo|cotton|embroidered|embroidery|print|printed|classic|heavy|vintage|faded|distressed|mini|small|big|back|front|new|edition|ami)$/i;
  var COLORS = /^(black|white|navy|grey|gray|red|blue|green|brown|beige|cream|pink|purple|yellow|orange|olive|washed|ivory|off|light|dark|bone|sand|khaki|silver|gold)$/i;
  function tokens(title) {
    return String(title).toUpperCase().replace(/T-SHIRT/g, 'TSHIRT').split(/[^A-Z0-9ÁÉÍÓÚÑ]+/).filter(function (w) {
      return w.length >= 3 && !/^\d+$/.test(w) && !NOISE.test(w);
    });
  }
  function findSet(current, same, limit) {
    if (same.length < 2) return [];
    // palabras demasiado comunes en la marca no definen un set
    var freq = {};
    same.forEach(function (p) {
      var seen = {};
      tokens(p.t).forEach(function (w) { if (!seen[w]) { freq[w] = (freq[w] || 0) + 1; seen[w] = 1; } });
    });
    var max = Math.max(3, same.length * 0.35);
    var mine = tokens(current.t).filter(function (w) { return (freq[w] || 0) <= max; });
    var myBucket = bucket(current.y);
    var scored = [];
    same.forEach(function (p) {
      if (p.h === current.h || bucket(p.y) === myBucket || !p.img || !marketOk(p)) return;
      var theirs = tokens(p.t);
      var shared = mine.filter(function (w) { return theirs.indexOf(w) > -1; });
      var named = shared.filter(function (w) { return !COLORS.test(w); });
      if (named.length >= 1 && shared.length >= 2) scored.push({ p: p, s: shared.length });
    });
    scored.sort(function (a, b) { return b.s - a.s; });
    var out = [], used = {};
    scored.forEach(function (x) {
      var b = bucket(x.p.y);
      if (out.length < limit && !used[b]) { out.push(x.p); used[b] = 1; }
    });
    return out;
  }
  function esc(x) {
    return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function sized(src, w) { return src ? src.replace(/([?&])width=\d+/, '$1width=' + w) : ''; }
  function setItemHTML(p, cta) {
    var img = p.img
      ? '<img src="' + esc(sized(p.img, 240)) + '" srcset="' + esc(sized(p.img, 160)) + ' 160w, ' + esc(sized(p.img, 240)) + ' 240w" sizes="72px" alt="' + esc(p.alt) + '" loading="lazy" decoding="async">'
      : '';
    return '<li><a class="maison-card mset__item" href="' + esc(p.url) + '">' +
      '<div class="mset__img">' + img + '</div>' +
      '<div class="maison-card__info"><p class="maison-card__title">' + esc(p.t) + '</p>' +
      '<p class="maison-card__price">' + esc(p.price) + '</p>' +
      (p.sizes ? '<p class="maison-size">' + esc(p.sizes) + '</p>' : '') +
      '<span class="mset__cta">' + esc(cta) + '</span></div></a></li>';
  }

  class MaisonCompleteSet extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      var d = this.dataset;
      setTaken[d.handle] = true;
      if (this.hasAttribute('data-manual')) {
        this.querySelectorAll('a[href]').forEach(function (a) {
          var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
          if (m) setTaken[decodeURIComponent(m[1])] = true;
        });
        if (!this.querySelector('li')) this.hidden = true;
        resolveSet();
        return;
      }
      idle(() => this.load());
    }
    load() {
      var d = this.dataset;
      var current = { h: d.handle, t: d.title, v: d.vendor, y: d.type };
      vendorPool(d.vendorUrl).then((items) => {
        var picks = findSet(current, uniq(items), parseInt(d.limit, 10) || 3);
        if (picks.length) {
          this.querySelector('ul').innerHTML = picks.map(function (p) { return setItemHTML(p, d.cta || ''); }).join('');
          picks.forEach(function (p) { setTaken[p.h] = true; });
          this.hidden = false;
        }
        resolveSet();
      });
    }
  }

  /* ---------- Completá el look / También te puede gustar ---------- */
  class MaisonRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      // Se carga al acercarse a la vista: no compite con la carga de la ficha
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            this.io.disconnect();
            idle(() => this.load());
          }
        }, { rootMargin: '600px 0px' });
        this.io.observe(this);
      } else {
        idle(() => this.load());
      }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }

    load() {
      var d = this.dataset;
      var limit = parseInt(d.limit, 10) || 4;
      var lookList = this.querySelector('[data-list="look"]');
      var similarList = this.querySelector('[data-list="similar"]');
      var vendorUp = (d.vendor || '').toUpperCase();
      var myBucket = bucket(d.type);
      var wanted = LOOK[family(d.type)] || [];
      // Si no hay bloque "Completá el set" en la ficha, no hay que esperarlo
      if (!document.querySelector('maison-complete-set')) resolveSet();

      Promise.all([
        lookList ? recPool(d.productId, 'complementary') : Promise.resolve([]),
        recPool(d.productId, 'related'),
        vendorPool(d.vendorUrl),
        setDone,
        similarList ? vendorPool(d.typeUrl) : Promise.resolve([])
      ]).then((res) => {
        var complementary = uniq(res[0]).filter(eligible);
        // relacionadas + misma marca + mismo tipo de prenda (para que siempre alcance para llenar las filas)
        var candidates = uniq(res[1].concat(res[2], res[4])).filter(function (p) { return eligible(p) && p.img; });
        var taken = Object.assign({}, setTaken);
        taken[d.handle] = true;

        if (lookList) {
          // Siempre se completa la fila: primero las complementarias de Search & Discovery,
          // después una pieza por tipo que combine (primero la misma marca) y, si faltan,
          // cualquier pieza de otro tipo de prenda.
          var look = complementary.filter(function (p) { return !taken[p.h]; }).slice(0, limit);
          look.forEach(function (p) { taken[p.h] = true; });
          var used = {};
          look.forEach(function (p) { used[bucket(p.y)] = true; });
          [true, false].forEach(function (sameBrand) {
            wanted.forEach(function (b) {
              if (look.length >= limit || used[b]) return;
              var hit = candidates.filter(function (p) {
                return !taken[p.h] && bucket(p.y) === b && (p.v.toUpperCase() === vendorUp) === sameBrand;
              })[0];
              if (hit) { look.push(hit); used[b] = true; taken[hit.h] = true; }
            });
          });
          [true, false].forEach(function (sameBrand) {
            candidates.forEach(function (p) {
              if (look.length >= limit || taken[p.h] || bucket(p.y) === myBucket) return;
              if ((p.v.toUpperCase() === vendorUp) !== sameBrand) return;
              look.push(p); taken[p.h] = true;
            });
          });
          look = look.slice(0, limit);
          look.forEach(function (p) { taken[p.h] = true; });
          this.fill(lookList, look);
        }

        if (similarList) {
          // Mismo tipo de prenda (primero la misma marca); si faltan, la misma familia y después cualquiera
          var myFamily = family(d.type);
          function rank(p) {
            var level = bucket(p.y) === myBucket ? 0 : family(p.y) === myFamily ? 2 : 4;
            return level + (p.v.toUpperCase() === vendorUp ? 0 : 1);
          }
          var similar = candidates.filter(function (p) { return !taken[p.h]; });
          similar = similar.map(function (p, i) { return { p: p, r: rank(p), i: i }; })
            .sort(function (a, b) { return a.r - b.r || a.i - b.i; })
            .map(function (x) { return x.p; });
          this.fill(similarList, similar.slice(0, limit));
        }
      });
    }

    fill(list, items) {
      if (!items.length) return;
      var ul = list.querySelector('ul');
      ul.textContent = '';
      items.forEach(function (p) { ul.appendChild(p.tpl.content.cloneNode(true)); });
      list.hidden = false;
      if (window.Maison && window.Maison.reveal) window.Maison.reveal(list);
    }
  }

  window.MaisonRecommendations = true;
  if (!customElements.get('maison-complete-set')) customElements.define('maison-complete-set', MaisonCompleteSet);
  if (!customElements.get('maison-recommendations')) customElements.define('maison-recommendations', MaisonRecommendations);
})();
